<form
  *ngIf="form && formInitialized"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="p-fluid">
  <div class="grid">
    <app-form-field-wrapper [label]="'Name'" [name]="'name'">
      <input
        pInputText
        id="name"
        type="text"
        formControlName="name"
        class="p-input" />
    </app-form-field-wrapper>
    <app-form-field-wrapper [label]="'Subtitel'" [name]="'subtitle'">
      <input
        pInputText
        id="subtitle"
        type="text"
        formControlName="subtitle"
        class="p-input" />
    </app-form-field-wrapper>
    <app-form-field-wrapper [label]="'Beschreibung'" [name]="'description'">
      <textarea
        pInputTextarea
        id="description"
        formControlName="description"
        class="p-inputtextarea"></textarea>
    </app-form-field-wrapper>
    <app-form-field-wrapper
      *ngIf="store.asTree() as categories"
      [label]="'Übergeordneter Ordner'"
      [name]="'parent'"
      [formField]="form.get('parent')"
      [colSize]="8">
      <p-treeSelect
        containerStyleClass="w-full"
        formControlName="parent"
        [filter]="true"
        [options]="categories">
      </p-treeSelect>
    </app-form-field-wrapper>
    <app-form-field-wrapper
      [colSize]="4"
      [label]="'Gesperrt'"
      [name]="'locked'"
      [floatingLabel]="true">
      <p-inputSwitch id="locked" formControlName="locked"></p-inputSwitch>
    </app-form-field-wrapper>
  </div>
  <p-divider />

  <div class="grid">
    <app-workspace-dropdown
      name="workspaces"
      type="indicatorCategory"
      formControlName="workspaces"></app-workspace-dropdown>
  </div>
  <p-divider />

  <app-form-footer
    [cancelLevel]="1"
    [showRemoveButton]="
      !!(
        itemToEdit &&
        permissionService.checkIndicatorRights(itemToEdit._id, 'remove')
      )
    "
    [isEditMode]="!!itemToEdit"
    (removeClick)="
      itemToEdit ? removeCategory(itemToEdit) : undefined
    "></app-form-footer>
</form>
